import { reduxStoreTypes } from '@/type/redux-store';


export const SET_ROLES: reduxStoreTypes.RolesType = 'SET_ROLES';
export const setRoles = (params: Omit<reduxStoreTypes.RolesAction, 'type'>) => ({
    type: SET_ROLES,
    ...params
})